import * as React from "react";

import { useIsDarkThemeActive } from "utils/useTheme";

import defaultImage from "assets/images/emptyState/emptystate.svg";
import darkThemeImage from "assets/images/emptyState/emptyState_darkMode.svg";

const EmptyStateIcon = (): JSX.Element => {
    const isDarkTheme = useIsDarkThemeActive();

    if (isDarkTheme) {
        return <img src={darkThemeImage} alt="" />;
    }

    return <img src={defaultImage} alt="" />;
};

export default EmptyStateIcon;
